module.exports = __webpack_public_path__ + "img/stick_patrimoine_musee.a1d58262.svg";